/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：231
 */

module.exports = function (e) {
  return "object" === typeof e ? null !== e : "function" === typeof e
}
